class BundleProductSelector extends BaseBundleSelector {
  init() {
    const modal = document.getElementById('bundleModal');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    super.init();

    const radios = document.querySelectorAll('.option-selector__btns .opt-btn');
    const openModalBtn = document.getElementById('openBundleModal');

    if (radios) {
      radios.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          const variantId = e.target.dataset.variantId;
          const variantBtn = document.querySelector(
            `.own-selected-candies .own-variant-item[data-variant-id="${variantId}"]`
          );
          if (variantBtn) {
            this.selectVariant(variantBtn);
          }

          if (openModalBtn) {
            openModalBtn.dataset.variantId = variantId;
            openModalBtn.dataset.variantPrice = e.target.dataset.variantPrice;
            openModalBtn.dataset.variantTitle = e.target.dataset.variantTitle;
            openModalBtn.dataset.totalCandy = e.target.dataset.totalCandy;
            openModalBtn.dataset.premiumCandy = e.target.dataset.premiumCandy;
          }
        });
      });
    }

    if (openModalBtn) {
      openModalBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openBundleModal(openModalBtn);
      });
    }

    const preview_layout_btn = document.querySelector('.bundle-preview-layout-btn');
    if (preview_layout_btn) {
      preview_layout_btn.addEventListener('click', () => {
        document.querySelector('.bundle-footer-box').classList.toggle('preview-list-view');
        if (document.querySelector('.bundle-footer-box').classList.contains('preview-list-view')) {
          preview_layout_btn.textContent = 'Hide Details';
        } else {
          preview_layout_btn.textContent = 'View Details';
        }
      });
    }
  }

  getProductCard(productId) {
    return document.querySelector(`.bundle-modal .product-grid [data-product-id="${productId}"]`);
  }

  matchesCard(card, query, activeTags) {
    const title = (card.dataset.productTitle || '').toLowerCase();
    const cardTags = (card.dataset.productTags || '').toLowerCase();

    const matchesSearch = title.includes(query);
    const matchesTags = activeTags.some((tag) => cardTags.includes(tag));

    return (query === '' || matchesSearch) && (activeTags.length === 0 || matchesTags);
  }

  bindEvents() {
    super.bindEvents();

    const closeBtn = document.getElementById('closeBundleModal');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }

    const overlay = document.querySelector('.modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.closeModal());
    }

    document.addEventListener('click', (e) => {
      const ownVariantItem = e.target.closest('.own-variant-item');
      if (ownVariantItem) {
        e.preventDefault();
        this.openModalForVariant(ownVariantItem);
      }
    });

    const layoutAddToCartBtn = document.getElementById('bundleAddToCartBtn');
    if (layoutAddToCartBtn) {
      layoutAddToCartBtn.addEventListener('click', () => {
        this.addBundleToCart();
      });
    }
  }

  openModalForVariant(variantItem) {
    const variantId = variantItem.dataset.ownVariantId || variantItem.dataset.variantId;
    const variantBtn = document.querySelector(
      `.own-selected-candies .own-variant-item[data-variant-id="${variantId}"]`
    );
    if (variantBtn) {
      this.selectVariant(variantBtn);
      this.openModal();
    }
  }

  updateVariantInfo() {
    if (this.currentVariantData) {
      const bundleSizeText = document.querySelector('.bundle-size-text');
      if (bundleSizeText) {
        bundleSizeText.textContent = this.maxItems;
      }
      const bundlePremiumText = document.querySelector('.bundle-premium-text');
      if (bundlePremiumText) {
        bundlePremiumText.textContent = this.maxPremiumItems;
      }
    }
    super.updateVariantInfo();
  }

  openModal() {
    if (!this.currentVariantId) {
      alert('Please select a variant first');
      return;
    }
    const modal = document.getElementById('bundleModal');
    if (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      document.body.classList.add('modal-body-overlay');
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  closeModal() {
    const modal = document.getElementById('bundleModal');
    if (modal) {
      modal.classList.remove('active');
    }
    document.body.style.overflow = '';
    document.body.classList.remove('modal-body-overlay');
  }

  renderPreviewItem(product) {
    return `
      <div class="preview-item-inner">
        <div class="preview-img-title">
          <div class="preview-item-bg">
            <img src="${product.image}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;">
            <span class="preview-img-count">1</span>
          </div>
          <h5 class="preview-title">${product.title}</h5>
        </div>
        <div class="preview-item-controls">
          <span class="preview-item-count">1</span>
          <button class="remove-btn" data-product-id="${product.id}">×</button>
        </div>
      </div>
    `;
  }

  showEmptyPreview(preview) {
    const emptyState = document.createElement('div');
    emptyState.className = 'preview-empty-state';
    emptyState.innerHTML = `
      <div class="empty-state-content">
        <div class="empty-state-icon">🍭</div>
        <p class="empty-state-text">No candies selected yet</p>
        <p class="empty-state-subtext">Choose your favorite candies to create the perfect bundle</p>
      </div>
    `;
    preview.appendChild(emptyState);
  }

  saveVariantSelections() {
    super.saveVariantSelections();
    this.updateOwnVariantDisplay();
  }

  updateOwnVariantDisplay() {
    if (this.currentVariantId) {
      const ownVariantItem = document.querySelector(`[data-own-variant-id="${this.currentVariantId}"]`);
      if (ownVariantItem) {
        const currentCount = Array.from(this.selectedProducts.values()).reduce(
          (sum, product) => sum + product.quantity,
          0
        );

        const currentSpan = ownVariantItem.querySelector('.own-candy-current');
        if (currentSpan) {
          currentSpan.textContent = currentCount;
        }

        this.updateOwnVariantSlots(ownVariantItem);
      }
    }
  }

  updateOwnVariantSlots(ownVariantItem) {
    const slotsContainer = ownVariantItem.querySelector('.own-selected-list');
    if (!slotsContainer) return;

    const slots = slotsContainer.querySelectorAll('.own-selected-item');
    const selectedProducts = Array.from(this.selectedProducts.values());
    let slotIndex = 0;

    slots.forEach((slot) => {
      slot.innerHTML = `
        <span class="icon-plus tw-w-[20px] tw-h-[20px] tw-flex tw-items-center tw-justify-center tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-bg-[url(https://cdn.shopify.com/s/files/1/0608/5512/4191/files/icon-plus.svg)] tw-bg-no"></span>`;
      slot.classList.remove('filled');
      slot.classList.add('empty');
    });

    selectedProducts.forEach((product) => {
      for (let i = 0; i < product.quantity && slotIndex < slots.length; i++) {
        const slot = slots[slotIndex];
        slot.innerHTML = `
          <img src="${product.image}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;">
          <button class="remove-btn" data-product-id="${product.id}">×</button>
        `;
        slot.classList.remove('empty');
        slot.classList.add('filled');

        const removeBtn = slot.querySelector('.remove-btn');
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.decreaseQuantity(product.id);
        });

        slotIndex++;
      }
    });
  }

  updateProgressUI() {
    super.updateProgressUI();

    const remainingText = document.querySelector('.bundle-remaining-text');
    const addToCartBtn = document.getElementById('bundleAddToCartBtn');

    if (!remainingText || !this.maxItems) return;

    const selectedCount = this.getCurrentTotalCount();
    const remaining = this.maxItems - selectedCount;

    if (remaining > 0) {
      remainingText.textContent = `Add ${remaining} More to Complete`;
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled');
      }
    } else {
      remainingText.textContent = `Add to Cart`;
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
      }
    }
  }

  addToCart() {
    super.addToCart();
    this.closeModal();
  }

  openBundleModal(button) {
    const variantId = button.dataset.variantId;
    const variantPrice = parseFloat(button.dataset.variantPrice) * 100; // cents
    const variantTitle = button.dataset.variantTitle;
    const totalCandy = parseInt(button.dataset.totalCandy, 10);
    const premiumCandy = parseInt(button.dataset.premiumCandy, 10);

    this.currentVariantId = variantId;
    this.maxItems = totalCandy;
    this.maxPremiumItems = premiumCandy;
    this.currentVariantData = {
      id: variantId,
      title: variantTitle,
      price: variantPrice,
      totalCandy,
      premiumCandy,
    };

    this.loadVariantSelections();
    this.updateVariantInfo();
    this.updatePreview();
    this.updateProgressUI();
    this.updateAddToCartButton();

    const modal = document.getElementById('bundleModal');
    if (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      document.body.classList.add('modal-body-overlay');
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
}

window.BundleProductSelector = BundleProductSelector;

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const optionList = document.querySelectorAll('.option-selector__btns .opt-btn');
  if (optionList) {
    optionList.forEach((option) => {
      option.addEventListener('change', (input) => {
        const vId = input.target.dataset.variantId;
        const candyPreviewSelected = document.querySelector(
          `.own-selected-candies .own-variant-item[data-own-variant-id="${vId}"]`
        );

        if (candyPreviewSelected) {
          const candyPreviewList = document.querySelectorAll('.own-selected-candies .own-variant-item');
          candyPreviewList.forEach((item) => {
            item.classList.remove('selected');
          });
          candyPreviewSelected.classList.add('selected');
        }
      });
    });
  }

  const selector = new BundleProductSelector();

  const selectedVariantItem = document.querySelector('.own-selected-candies .own-variant-item.selected');
  if (selectedVariantItem) {
    selector.openModalForVariant(selectedVariantItem);
    selector.closeModal();
  }

  const filterBtn = document.querySelector('.bundle-filter-btn');
  const filterDropdown = document.querySelector('.bundle-filter-dropdown');
  if (filterBtn && filterDropdown) {
    filterBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      filterDropdown.classList.toggle('dropdown-open');
    });

    document.addEventListener('click', (e) => {
      if (!filterDropdown.contains(e.target) && !filterBtn.contains(e.target)) {
        filterDropdown.classList.remove('dropdown-open');
      }
    });
  }
});
